import "../../assets/styles/styles.css"
import "./DeckBuilder.css";

import { useState, useEffect, useRef } from "react";

import { Container, Row, Col, Tooltip, OverlayTrigger, Dropdown, Modal, Offcanvas, Navbar } from "react-bootstrap";
import '../../assets/styles/styles.css';
import '../../assets/styles/lobby-table.css';

import CardPreview from "./components/CardPreview.jsx";
import AvailableCard from "./components/AvailableCard.jsx";
import PowerDeckContainer from './components/PowerDeckContainer';
import InfoNav from "../lobby/components/InfoNav.jsx";
import BootstrapToast from '../../components/BootstrapToast.jsx';
import { user, client, session, socketConnected, socket } from '../../utils/nakama';
import opCodes from '../../constants/opCodes.jsx'
import LandscapeModal from "../../components/LandscapeModal";
import { playSound, handleClickSound } from "../game/scenes/classes/PlaySound";

import bonezIcon from '../../assets/images/bonez_icon.svg'
import xpIcon from '../../assets/images/xp.png'
import settingsIcon from '../../assets/images/settings_icon.png'
import infoIcon from '../../assets/images/info_icon.png'
import vipIcon from '../../assets/images/gold_vip_icon.png'

import { AUTO } from "phaser";

let disconnectTimer = 0; //seconds

export default function DeckBuilder({ setCurrentScreen, matchId, opCodeData, setOpCodeData }) {
    const [userLevels, setUserLevels] = useState();
    const [zoomBalance, setZoomBalance] = useState();
    const [cardCollection, setCardCollection] = useState({ housePowerCards: new Map(), nftPowerCards: new Map() });
    const [refreshCardCollectionTrigger, setRefreshCardCollectionTrigger] = useState(false); //changed when a card is dropped into the power deck

    const [droppedItems, setDroppedItems] = useState([]);
    const [dropIndicator, setDropIndicator] = useState(false);
    const [cardPreview, setCardPreview] = useState("");
    const [houseCardPreview, setHouseCardPreview] = useState();

    const [playerReady, setPlayerReady] = useState(false);
    const [opponentReady, setOpponentReady] = useState(false);

    const [showToast, setShowToast] = useState(false);

    //Power deck related variables
    const [deckLoaded, setDeckLoaded] = useState(false);
    const [cardSlots, setCardSlots] = useState([]); // for displaying the cards in the power deck
    const deckLoadedRef = useRef(deckLoaded);
    const [isShowingLandscapeModal, setIsShowingLandscapeModal] = useState(false);

    //update the card count (/10)
    const [cardCount, setCardCount] = useState(0);
    const cardCountRef = useRef(cardCount);
    const setCardCountRef = (update) => {
        cardCountRef.current = update;
        setCardCount(update);
    }

    const [selectedOption, setSelectedOption] = useState('Both');

    const sidebarRef = useRef(null);
    const settingsButtonRef = useRef(null);
    const infoButtonRef = useRef(null);

    const [isSettingsBarActive, setIsSettingsBarActive] = useState(false);
    const [isInfoBarActive, setIsInfoBarActive] = useState(false);
    
    const LOCAL_STORAGE_MUSIC_VOLUME = 'musicVolume';
    const LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

    // fetching values from local storage or use default values
    const musicVolumeFromStorage = localStorage.getItem(LOCAL_STORAGE_MUSIC_VOLUME);
    const soundVolumeFromStorage = localStorage.getItem(LOCAL_STORAGE_SOUND_VOLUME);

    const initialMusicVolume = musicVolumeFromStorage !== null ? +musicVolumeFromStorage : 12.5;
    const initialSoundVolume = soundVolumeFromStorage !== null ? +soundVolumeFromStorage : 12.5;

    const [musicVolume, setMusicVolume] = useState(initialMusicVolume);
    const [soundVolume, setSoundVolume] = useState(initialSoundVolume);

    const musicSliderBackground = {
        background: `linear-gradient(90deg, #00D1FF 0%, #00D1FF ${musicVolume}%, #5A4F71 ${musicVolume}%, #5A4F71 100%)`
    };
    const soundSliderBackground = {
        background: `linear-gradient(90deg, #00D1FF 0%, #00D1FF ${soundVolume}%, #5A4F71 ${soundVolume}%, #5A4F71 100%)`
    };

    useEffect(() => {
        const musicElements = document.querySelectorAll(".music");
        const soundElements = document.querySelectorAll(".sound-fx");

        musicElements.forEach(element => {
            element.volume = musicVolume / 100;
        });

        soundElements.forEach(element => {
            element.volume = soundVolume / 100;
        });
    }, [musicVolume, soundVolume]);

    // Update local storage when volumes change
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_MUSIC_VOLUME, musicVolume);
        localStorage.setItem(LOCAL_STORAGE_SOUND_VOLUME, soundVolume);
    }, [musicVolume, soundVolume]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && !settingsButtonRef.current.contains(event.target)) {
                setIsSettingsBarActive(false);
            }
        }
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sidebarRef]);

    useEffect(() => {
        if (cardSlots) {
            let count = 0;
            cardSlots.map((slot) => {
                if (slot.image !== "") {
                    count += slot.count;
                }
            })
            setCardCountRef(count);
        }
    }, [cardSlots, cardCount]);

    //function to pass to the card collection component to change the card in the left pane preview screen
    const handleCardSelect = (cardName, houseCard) => {
        // console.log(cardName)
        setCardPreview(cardName);
        setHouseCardPreview(houseCard);
    }

    //dnd function to track when a card has been placed in another row
    function isDropped(cardName) {
        //have to account for card count when its added
        return droppedItems.indexOf(cardName) > -1;
    }

    async function handleReady() {
        if (socketConnected && matchId !== "") {
            try {
                await socket.sendMatchState(matchId, opCodes.playerReady, "true");
                setPlayerReady(true);
                setShowToast(true);
            } catch (err) {
                console.log("Error readying: ", err)
            }
        }
    }
    
    async function handleNotReady() {
        if (socketConnected && matchId !== "") {
            try {
                await socket.sendMatchState(matchId, opCodes.playerReady, "false");
                setPlayerReady(false);
            } catch (err) {
                console.error("Error not readying: ", err)
            }
        }
    }

    // This effect will check the card count and call handleNotReady if it is less than 10
    useEffect(() => {
        if (cardCountRef.current !== 10 && playerReady === true) {
            handleNotReady();
        }
    }, [cardCountRef.current]);

    useEffect(() => {
        async function getUserInfo() {
            if (user && user.metadata) {
                const objects = await client.readStorageObjects(session, {
                    "object_ids": [{
                        "collection": "user_levels",
                        "key": "user_levels",
                        "user_id": session.user_id
                    }]
                })
                setUserLevels(objects.objects[0].value.data);

                var account = await client.getAccount(session);
                setZoomBalance(parseInt(JSON.parse(account.wallet).zoom));
            }
        }
        getUserInfo();
    }, []);

    //get available power cards
    useEffect(() => {
        const getPowerCards = async () => {
            const response = ((await client.rpc(session, "fetchAvailablePowerCards", "deck-builder")).payload);
            if (response.housePowerCards && response.nftPowerCards) {
                setCardCollection({
                    housePowerCards: new Map(response.housePowerCards),
                    nftPowerCards: new Map(response.nftPowerCards)
                });
                setRefreshCardCollectionTrigger(false);
            }
            else {
                console.log("Error fetching power cards: ", response.message)
            }
        }
        getPowerCards();
    }, [refreshCardCollectionTrigger]);

    //update rendering functions
    const [renderHouseCards, setRenderHouseCards] = useState(() => () => { });
    const [renderNftCards, setRenderNftCards] = useState(() => () => { });
    useEffect(() => {
        const renderHouseCardsFunction = () => {
            const renderCards = [];
            for (const [key, value] of cardCollection.housePowerCards.entries()) {
                renderCards.push(
                    <div key={key} className="grid-item">
                        <AvailableCard
                            setDropIndicator={setDropIndicator}
                            handleCardSelect={handleCardSelect}
                            cardCollection={cardCollection}
                            isDropped={isDropped(key)}
                            houseCard={true}
                            cardName={key}
                            numberOwned={value}
                            draggable={cardCountRef.current < 10}
                        />
                    </div>
                );
            }
            return renderCards;
        };
        setRenderHouseCards(() => renderHouseCardsFunction);

        const renderNftCardsFunction = () => {
            const renderCards = [];
            for (const [key, value] of cardCollection.nftPowerCards.entries()) {
                renderCards.push(
                    <div key={key} className="grid-item">
                        <AvailableCard
                            setDropIndicator={setDropIndicator}
                            cardCollection={cardCollection}
                            handleCardSelect={handleCardSelect}
                            isDropped={isDropped(key)}
                            houseCard={false}
                            cardName={key}
                            numberOwned={value}
                            draggable={cardCountRef.current < 10}
                        />
                    </div>
                );
            }
            return renderCards;
        };
        setRenderNftCards(() => renderNftCardsFunction);
    }, [cardCollection]);

    //get power deck
    useEffect(() => {
        async function getPowerDeck() {
            const powerDeck = await client.readStorageObjects(session, {
                "object_ids": [{
                    "collection": "bonez_power_deck",
                    "key": "power_deck",
                    "user_id": session.user_id
                }]
            })

            // console.log(powerDeck.objects[0].value.data);
            // setNakamaDeck(powerDeck.objects[0].value.data);
            const nakamaDeck = powerDeck.objects[0].value.data
            const housePowerCards = new Map(nakamaDeck.housePowerCards);
            const nftPowerCards = new Map(nakamaDeck.nftPowerCards);

            let index = 0;
            let droppedIndex = 0;
            var newDeck = [
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 },
                { image: "", count: 0 }
            ];

            housePowerCards.forEach((value, key) => {
                //if (!deckLoaded) {
                newDeck[index] = {
                    image: key,
                    count: value,
                    houseCard: true
                }
                //}
                if (key !== "") index++;
                droppedIndex += value;
                for (var i = 0; i < value; i++) {
                    if (cardCountRef.current < droppedIndex) {
                        droppedItems.push(key);
                    }
                }
            });
            nftPowerCards.forEach((value, key) => {
                //if (!deckLoaded) {
                newDeck[index] = {
                    image: key,
                    count: value,
                    houseCard: false,
                }
                //}
                if (key !== "") index++;
                droppedIndex += value;
                for (var j = 0; j < value; j++) {
                    if (cardCountRef.current < droppedIndex) {
                        droppedItems.push(key);
                    }
                }
            });
            setCardSlots(newDeck);
            //setDeckLoaded(true);
        }
        getPowerDeck();
    }, [deckLoadedRef, refreshCardCollectionTrigger]);

    // useEffect(() => {
    //     const leaveChat = async (room) => {
    //         console.log()
    //         // await socket.leaveChat(room);
    //     }
    //     if (socketConnected) leaveChat("BonezLobby");
    // }, [socketConnected])


    //op code listener
    const [opponentData, setOpponentData] = useState(null);
    const [showDisconnectModal, setShowDisconnectModal] = useState(false);
    const [timer, setTimer] = useState(120); //seconds
    const timeoutRef = useRef(null);
    useEffect(() => {
        if (opCodeData) {
            //if no server ping in 5 seconds, return to lobby
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                clearTimeout(timeoutRef.current);
                setOpCodeData(null);
                setCurrentScreen("lobby");
            }, 5000);

            const decodedData = JSON.parse(new TextDecoder().decode(opCodeData.data));
            switch (opCodeData.op_code) {
                case opCodes.player2Info: {
                    console.log("player 2 ready")
                    setOpponentReady(true);
                    break;
                }
                case opCodes.player1Info: {
                    console.log("player 1 ready")
                    setOpponentReady(true);
                    break;
                }
                case opCodes.illegitimateMatch: {
                    console.log("illegitamate match, returning to lobby");
                    setOpponentData(null);
                    setCurrentScreen("lobby");
                    break;
                }
                case opCodes.notReady: {
                    if(decodedData.isReady === false){
                        setOpponentReady(false);
                    }
                }
                case opCodes.matchStartPlayer1: {
                    setOpponentData(decodedData);
                    break;
                }
                case opCodes.matchStartPlayer2: {
                    setOpponentData(decodedData);
                    break;
                }
                case opCodes.rejoinDeckBuilder: {
                    setOpponentData(decodedData);
                    setOpponentReady(decodedData.isReady);
                    break;
                }
                case opCodes.opponentDisconnected: {
                    console.log("disconnect timer updated (Deck Builder)");
                    setOpponentData(decodedData);
                    setOpponentReady(false); //server side sets their ready status to false
                    disconnectTimer = decodedData.timeRemaining;
                    setShowDisconnectModal(true);
                    break;
                }
                case opCodes.opponentReconnected: {
                    console.log("opponent reconnected (Deck Builder)");
                    setOpponentData(decodedData);
                    setShowDisconnectModal(false);
                    break;
                }
                case opCodes.winMatch: {
                    console.log("match won by opponent disconnect (Deck Builder)");
                    clearTimeout(timeoutRef.current);
                    setCurrentScreen("lobby");
                    break;
                }
                case opCodes.updateDeckBuilderTimer: {
                    setOpponentData(decodedData);
                    setTimer(decodedData.timeRemaining);
                    break;
                }
                case opCodes.gameData: { //LOAD GAME
                    console.log("gameData recieved. Loading game (Deck Builder)");
                    clearTimeout(timeoutRef.current);
                    setCurrentScreen("game");
                    break;
                }
                case opCodes.waitingMatchStart: { //LOAD GAME
                    console.log("gameData recieved. Loading game (Deck Builder)");
                    clearTimeout(timeoutRef.current);
                    setCurrentScreen("game");
                    break;
                }
                default: {
                    console.log("Unknown op code (Deck Builder): ", opCodeData.op_code);
                }
            }
        }
        else {
            setCurrentScreen("lobby");
        }
    }, [opCodeData]);

    const tooltip = (
        <Tooltip id="tooltip">
            {cardCountRef.current < 10 || playerReady ?
                <>Need 10 Cards To Play</> :
                <>Press To Ready</>
            }

        </Tooltip>
    );

    useEffect(() => {
        if (window.innerHeight > window.innerWidth) {
            setIsShowingLandscapeModal(true)
        } else {
            setIsShowingLandscapeModal(false)
        }
    }, [window.innerHeight, window.innerWidth])

    return (
        <div className="deckbuilder-container">
            <Modal show={isShowingLandscapeModal} centered>
                <LandscapeModal />
            </Modal>
            {opponentData &&
                <Modal show={showDisconnectModal} centered>
                    <div className="whole-container">
                        <h1 className="container-subtitle" style={{ color: "#00D1FF" }}>{opponentData.username} has disconnected</h1>
                        <h1 style={{ display: "inline" }} className="container-body-text">Time remaining for player to re-join:</h1>
                        <h1 className="container-title" style={{ color: "#00D1FF" }}>{new Date(disconnectTimer * 1000).toISOString().substring(14, 19)}</h1>
                    </div>
                </Modal>
            }
            <Container fluid>
                <Navbar className="taskbar">
                    <Container fluid style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                        <Row className="flex-nowrap" style={{ width: '100%', display: 'flex' }}>
                            <Col xs="auto" sm="2" lg="auto" xl="3" xxl="auto" style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                    className="icon-chipz"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    alt="Chipz icon"
                                />
                                <span className="container-body-text chipz-amount" style={{ color: "#00D1FF", marginLeft: "5%" }}>
                                    {zoomBalance && zoomBalance.toLocaleString()}
                                </span>
                            </Col>
                            <Col xs="2" sm="2" md="2" lg="2" style={{ display: 'flex', alignItems: 'center' }}>
                                <img 
                                    className="icon-bonez"
                                    title="Zoombies Bones" 
                                    alt="" 
                                    src={bonezIcon} 
                                />
                                <span className="container-body-text bone-amount" style={{ marginLeft: "5%" }}>
                                    {userLevels && userLevels.bone.toLocaleString()}
                                </span>
                            </Col>
                            <Col xs="2" sm="3" md="3" lg="3" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="xp-container">
                                    <img 
                                        className="icon-xp"
                                        title="XP"
                                        alt=""
                                        src={xpIcon}
                                    />
                                    <span className="container-body-text xp-amount" style={{ color: "#FFC350"}}>
                                        {userLevels && userLevels.xp.toLocaleString()}
                                    </span>
                                </div>
                            </Col>
                            <Col xs="2" sm="4" md="4" lg="4" className="opponent-text" style={{ display: 'flex', alignItems: 'center', minWidth: '160px', flex: '1 2 auto' }}>
                                {opponentData && opponentData.username !== undefined &&
                                    <h1 className="page-subtitle" style={{ color: opponentReady ? "#A7E73C" : "#FF0A54" }}>
                                        {opponentReady ? `${opponentData.username} is READY to PLAY` : `${opponentData.username} is BUILDING their DECK`}
                                    </h1>
                                }
                            </Col>
                            <Col xs="1" sm="1" md="1" lg="1" className="settings-button-container" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                <button
                                    ref={settingsButtonRef}
                                    className={`settings-button ${isSettingsBarActive ? 'active' : ''}`}
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsSettingsBarActive(!isSettingsBarActive);
                                    }}
                                >
                                    <img
                                        className="image-settings"
                                        title="Settings"
                                        src={settingsIcon}
                                        alt="Settings"
                                    />
                                </button>
                            </Col>
                            <Col xs="auto" className="info-button-container" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                <button
                                    ref={infoButtonRef}
                                    className="info-button"
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsInfoBarActive(!isInfoBarActive);
                                    }}
                                >
                                    <img
                                        className="image-info"
                                        title="Info"
                                        src={infoIcon}
                                        alt="Info"
                                    />
                                </button>
                            </Col>
                        </Row>
                    </Container>
                    <audio id="clickSound" className="sound-fx" hidden>
                        <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
                    </audio>
                </Navbar>

                <Offcanvas show={isSettingsBarActive} onHide={() => setIsSettingsBarActive(false)}  placement="end" style={{ backgroundColor: '#1B3A5D' }}>
                    <Offcanvas.Header className="offcanvas-header-container" closeButton style={{ justifyContent: 'center' }}>
                        <Offcanvas.Title 
                            style={{
                                fontFamily: 'Truculenta, sans-serif',
                                fontSize: '40px',
                                fontWeight: 'bold',
                                color: 'white',
                                marginLeft: '5%',
                                marginBottom: '-5%'
                            }}
                        >
                            Settings
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "5.5%" }}>Music</span>
                            <input 
                                className="volume-slider"
                                type="range"
                                min="0"
                                max="100"
                                value={musicVolume}
                                onChange={e => setMusicVolume(e.target.value)}
                                style={musicSliderBackground}
                            />

                            <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "6.5%" }}>Sound FX</span>
                            <input 
                                className="volume-slider"
                                type="range"
                                min="0"
                                max="100"
                                value={soundVolume}
                                onChange={e => setSoundVolume(e.target.value)}
                                style={soundSliderBackground}
                            />
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>

                <InfoNav
                    isInfoBarActive={isInfoBarActive}
                    setIsInfoBarActive={setIsInfoBarActive}
                />

                <Row className="second-row-height">
                    <Col lg={4} sm={4}>
                        <div 
                            className="button-container" style={{ textAlign: "left", marginLeft: "1rem" }}>                         
                        </div>
                    </Col>
                    <Col lg={4} sm={4}>
                        <div className="page-title-container" style={{ textAlign: "center" }}>
                            <div className="whole-container pot">
                                <span className="container-body-text pot-text">POT</span>    
                                {window.Phaser.wagerType === "zoom" ? (
                                    <img
                                    className="icon pot-chipz"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    alt="Chipz icon"
                                />
                                ) : (
                                    <img className="icon pot-bonez" title="Zoombies Bones" alt="" src={bonezIcon}/>
                                )}
                                <span className="container-body-text pot-amount">{window.Phaser.potAmount.toLocaleString()}</span>
                            </div>     
                        </div>
                    </Col>
                    <Col lg={4} sm={4}>
                        <div style={{ textAlign: "right", marginRight: "1rem" }}>
                            <div className="button-container">
                            {cardCountRef.current >= 10 ? (
                                <OverlayTrigger placement="bottom" overlay={tooltip}>
                                <button
                                    className={playerReady ? "button ready button-disabled" : "button ready"}
                                    disabled={playerReady}
                                    onClick={(e) => {
                                    playSound("clickSound");
                                    handleReady();
                                    }}
                                >
                                    <audio id="clickSound" className="sound-fx" hidden>
                                    <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
                                    Your browser does not support the audio element.
                                    </audio>
                                    <img
                                    src="https://zoombies.world/images/dapp/green_button_500.webp"
                                    alt=""
                                    style={{ width: "100%", height: "100%" }}
                                    />
                                    <span
                                    className="button-text"
                                    style={{ color: "#000000" }}
                                    >
                                    READY
                                    </span>
                                </button>
                                </OverlayTrigger>
                            ) : (
                                <div className="deckbuilding-text" style={{ 
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  height: '50px', // This should match the button's height
                                  color: "#A7E73C",
                                }}>
                                  <span>Add more cards to your power deck</span>
                                </div>
                              )}
                            </div>
                            <div className="mt-2" style={{ marginRight: "2%" }}>
                            <h1 className="countdown-text" style={{ color: "#FFFFFF" }}>
                                Game Automatically Starts in: <span style={{ color: "#A7E73C" }}>{new Date(timer * 1000).toISOString().substring(14, 19)}</span>
                            </h1>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col lg={3} sm={3}>
                        <CardPreview card={cardPreview} houseCard={houseCardPreview}/>
                    </Col>
                    <Col lg={6} sm={6}>
                        <div className="whole-container deck-drag" style={{ flex: "1" }}>
                            <div style={{ textAlign: "left", paddingLeft: "3%" }}>
                                <h1 className="container-title pink-text">Select Cards</h1>
                                <h1 className="container-body-text" style={{ color: '#AFAEE1', marginBottom: '0%'}}>
                                    Drag 10 cards into your power deck
                                    <Dropdown className="deck-dropdown" style={{ display: 'inline-block' }} onSelect={value => setSelectedOption(value)}>
                                        <Dropdown.Toggle 
                                            className="deck-dropdown-toggle" 
                                            variant="sucess"
                                            id="dropdown-basic" 
                                        >
                                            View
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="deck-dropdown-menu">
                                            <Dropdown.Item className="deck-dropdown-text" eventKey="House" style={{ color: "#B2F1FF" }}>House Power Cards</Dropdown.Item>
                                            <Dropdown.Item className="deck-dropdown-text" eventKey="NFT" style={{ color: "#B2F1FF" }}>Power Boost Cards</Dropdown.Item>
                                            <Dropdown.Item className="deck-dropdown-text" eventKey="Both" style={{ color: "#BD00FF" }}>Both</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </h1>
                            </div>
                            <div className="grid-container">
                                {cardCollection && (selectedOption === 'Both' || selectedOption === 'House') && renderHouseCards()}
                                {cardCollection && (selectedOption === 'Both' || selectedOption === 'NFT') && renderNftCards()}
                            </div>
                        </div>
                    </Col>
                    <Col lg={3} sm={3}>
                        <PowerDeckContainer
                            dropIndicator={dropIndicator}
                            droppedItems={droppedItems}
                            isDropped={isDropped}
                            cardCollection={cardCollection}
                            setCardCollection={setCardCollection}
                            setRefreshCardCollectionTrigger={setRefreshCardCollectionTrigger}
                            cardSlots={cardSlots}
                            setCardSlots={setCardSlots}
                        />
                    </Col>
                </Row>
            </Container>
            <BootstrapToast position={'bottom-start'} visible={showToast} background={'success'} setShowToast={setShowToast} text={"Succesfully Ready"} />
        </div >

    );
}